import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { GlitterHeart } from './GlitterHeart';
export function Footer() {
  return <footer className="bg-white border-t border-blush-100 pt-16 pb-8 relative overflow-hidden" data-id="element-21">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-blush-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-float" data-id="element-22" />
      <div className="absolute top-0 right-1/4 w-64 h-64 bg-lavender-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-23" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-25">
          <div className="col-span-1 md:col-span-2" data-id="element-26">
            <Link to="/" className="flex items-center gap-2 mb-4 group" data-id="element-27">
              <GlitterHeart size={22} className="group-hover:scale-125 transition-transform" data-id="element-28" />
              <span className="font-heading text-2xl font-semibold text-plum-700" data-id="element-29">
                Trippin' With Mandy™
              </span>
            </Link>
            <p className="text-plum-500 max-w-sm mb-6 leading-relaxed" data-id="element-30">
              Rebuilding the world one soul at a time. The Broken Beginning —
              and taking you with me.
            </p>
            <div className="flex gap-4" data-id="element-31">
              <a href="#" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="Instagram" data-id="element-32">
                <InstagramIcon className="w-5 h-5" data-id="element-33" />
              </a>
              <a href="#" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="TikTok" data-id="element-34">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-35">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-36" />
                </svg>
              </a>
              <a href="mailto:trippinwithmandy@gmail.com" className="p-2 bg-blush-50 rounded-full text-plum-500 hover:text-cta-500 hover:bg-blush-100 transition-colors" aria-label="Email" data-id="element-37">
                <MailIcon className="w-5 h-5" data-id="element-38" />
              </a>
            </div>
          </div>

          <div data-id="element-39">
            <h3 className="font-heading font-semibold text-lg text-plum-700 mb-4" data-id="element-40">
              Explore
            </h3>
            <ul className="space-y-3" data-id="element-41">
              <li data-id="element-42">
                <Link to="/" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-43">
                  Home
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/about" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-45">
                  About Mandy
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/courses" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-47">
                  Courses
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/coaching" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-49">
                  1:1 Coaching
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/travel" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-51">
                  Travel Planning
                </Link>
              </li>
              <li data-id="element-52">
                <a href="https://beacons.ai/trippinwithmandy" target="_blank" rel="noopener noreferrer" className="text-cta-500 font-bold hover:text-cta-600 transition-colors inline-flex items-center gap-1" data-id="element-53">
                  Shop My Favorites <GlitterHeart size={12} data-id="element-54" />
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-55">
            <h3 className="font-heading font-semibold text-lg text-plum-700 mb-4" data-id="element-56">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-57">
              <li data-id="element-58">
                <Link to="/app" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-59">
                  The App (Coming Soon)
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/free-resources" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-61">
                  Free Resources
                </Link>
              </li>
              <li data-id="element-62">
                <a href="mailto:trippinwithmandy@gmail.com" className="text-plum-500 hover:text-plum-700 transition-colors" data-id="element-63">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-blush-100 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-64">
          <p className="text-sm text-plum-500" data-id="element-65">
            © {new Date().getFullYear()} Trippin' With Mandy™. All rights
            reserved.
          </p>
          <p className="text-sm text-plum-500 flex items-center gap-1" data-id="element-66">
            Made with <GlitterHeart size={16} data-id="element-67" /> and a whole lot of grit
          </p>
        </div>
      </div>
    </footer>;
}